import { writable } from "svelte/store";

const waiting        = writable(true);
const dim            = writable(false);
const disableButtons = writable(false);
const customExchange = writable(false);

export {
    waiting,
    dim,
    disableButtons,
    customExchange
};
